<template>
  <div class="notice-block">
    <GwMessage
      :message="{
        hide: true,
        icon: 'mdi-lock',
        type: 'error',
        text: $t('messages.upload_limit_reached', { upload_reset_days: 30 }),
      }"
      class="mt-8"
    />

    <v-btn
      :to="{
        name: 'SubscriptionOverview',
      }"
      color="primary"
      class="mt-6 mb-8 mx-auto"
      size="large"
      data-tst="upload_btn_upgrade"
    >
      <v-icon class="mr-2">mdi-crown</v-icon>
      {{ $t('btn.upgrade') }}
    </v-btn>
  </div>
</template>

<script>
import GwMessage from '@/components/Messages/GwMessage'

export default {
  name: 'UploadLimitReachedNote',
  components: {
    GwMessage,
  },
}
</script>
<style lang="scss" scoped>
.notice-block {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
